<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Admission Confirmed Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Academic Year"
                        outlined
                        @change="getStd();"
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        item-value="std_id"
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        persistent-hint
                        @change="getStdRound()"
                        hint="Please Select Standard"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="stream_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="stream"
                        :items="stream_list"
                        item-text="str"
                        item-value="str_id"
                        label="Stream"
                        outlined
                        persistent-hint
                        hint="Please Select Stream"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="round_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="round"
                        item-value="id"
                        :items="round_list"
                        item-text="name"
                        label="Round"
                        outlined
                        persistent-hint
                        hint="Please Select Round"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" class="pt-8 pl-2" v-if="stream && sel_std_data && sel_ay_data">
                    <v-btn color="primary" @click="fetchAdmissionConfirmedStudentReport()"> Fetch </v-btn>
                </v-col>
            </v-row>
             <v-row justify="center" dense v-if="confirmed_student_list!=''">
            <strong>Admission #  {{ confirmed_student_count }}</strong>
           </v-row>
            <v-data-table
                v-if="confirmed_student_list!=''"
                :headers="headers"
                @current-items="getFiltered"
                :items-per-page="-1"
                :items="bookList1"
                dense
                sort-by=""
                class="elevation-1 mytable"
                :search="search"
                show-select
                v-model="selected"
                item-key="coff_id"
            >
                <template v-slot:top class="pb-5">
                    <v-row justify="center" align="center">
                        <tr class="t-row">
                            <div>
                                <th>
                                    <v-row>
                                        <span v-for="header in headers" :key="header.text">
                                            <span v-if="filters.hasOwnProperty(header.value)">
                                                <v-autocomplete
                                                    class="mr-2 pb-5 pt-2"
                                                    flat
                                                    hide-details
                                                    small
                                                    rounded
                                                    dense
                                                    outlined
                                                    color="#0F2027"
                                                    :label="header.text"
                                                    multiple
                                                    clearable
                                                    :items="columnValueList(header.value)"
                                                    v-model="filters[header.value]"
                                                ></v-autocomplete>
                                            </span>
                                        </span>
                                    </v-row>
                                </th>
                            </div>
                        </tr>
                    </v-row>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import { stream } from "xlsx";
    export default {
        components: {
            Breadcrumbs,
        },

        data() {
            return {
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                overlay: false,
                stream: null,
                round: null,
                round_list:null,
                confirmed_student_list: [],
                confirmed_student_count:null,
                filterArr: [],
                filters: {
                    applicationid: [],
                    registration_number: [],
                    name_of_candidate: [],
                    category: [],
                    round: [],
                    gender:[]
                },
                headers: [
                    { text: "Sr. No.", value: "srno" },
                    { text: "Application Id", value: "applicationid" },
                    { text: "Registration Number", value: "registration_number" },
                    { text: "Student Name", value: "name_of_candidate" },
                    { text: "Round", value: "round" },
                    { text: "Merit Marks", value: "merit_marks" },
                    { text: "Merit No.", value: "merit_no" },
                    { text: "Email", value: "email" },
                    { text: "Mobile Number", value: "mobile_number" },
                    { text: "Gender", value: "gender" },
                    { text: "Category", value: "category" },
                    { text: "Academic Year", value: "ay" },
                    { text: "Standard", value: "standard" },
                    { text: "Stream", value: "stream" },
                ],
            };
        },
        computed: {
            bookList1() {
                return this.confirmed_student_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },

        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.confirmed_student_list.map((d) => d[val]);
            },
            getStdRound() {
            this.round_list = null
            this.round = null
              const formData = {
                   standard: this.sel_std_data,
              };
              axios
                  .post("/Admission/fetchAdmissionList", formData)
                  .then((res) => {
                      this.round_list = [{ id: 'null', name: 'All' }, ...res.data.admission_rounds_list];
                  })
                  .catch((error) => {
                      window.console.log(error);
                  })
                  .finally(() => {});
          },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async fetchAdmissionConfirmedStudentReport() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    std: this.sel_std_data,
                    stream: this.stream,
                    subject: this.subject,
                };
                try {
                    const res = await axios.post("/Admission/fetchAdmissionConfirmedStudentReport", data);
                    if (res.data.flag == "YES") {
                        this.confirmed_student_list = res.data.confirmed_student_list;
                        if(this.confirmed_student_list.length == 0){
                            this.showSnackbar("#b71c1c", "No Data Found....");
                        }
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        console.log(res.data);
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.sel_ay_data;
                        this.stream_list = res.data.stream_list;
                        this.category_list = res.data.category_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped></style>
